import { z } from 'zod';

export const healthResponseSchema = z.object({
  status: z.enum(['ok', 'not_ready']),
  service: z.enum(['api', 'worker']),
  timestamp: z.iso.datetime(),
});

export type HealthResponse = z.infer<typeof healthResponseSchema>;

export const supportedLocales = ['en', 'hu', 'ro'] as const;
export type SupportedLocale = (typeof supportedLocales)[number];

export function isSupportedLocale(candidate: unknown): candidate is SupportedLocale {
  return supportedLocales.some((locale) => locale === candidate);
}
export * from './environment.js';
export * from './permissions.js';
export * from './sections.js';
export * from './identity.js';
export * from './session-policy.js';
export * from './mail-settings.js';
export * from './club-data.js';
export * from './organization-logo.js';
export * from './people.js';
export * from './guardian-links.js';
export * from './structure.js';
export * from './club-membership.js';
export * from './hockey-profile.js';
export * from './imports.js';
export * from './scheduling.js';
export * from './training.js';
export * from './assessments.js';
export * from './billing.js';
export * from './competitions.js';
export * from './errors.js';
